<template>
  <div class="checkbox-group-items" :class="{ stacked: variant === 'stacked' }">
    <label
      v-for="(option, index) in optionItems"
      :key="`${name}${index}`"
      class="checkbox-group-items__item mb-0 text-mild"
      :for="`option-${name}-${option.value}`"
    >
      <input
        type="checkbox"
        class="d-none"
        v-model="checkedItemsValue"
        :value="option.value"
        :id="`option-${name}-${option.value}`"
        :name="name"
      />
      <div class="checkbox-group-items__item-content">
        <FeatherIcon icon="square" v-show="!option.checked" size="18" />
        <FeatherIcon
          icon="check-square"
          v-show="option.checked"
          size="18"
          class="text-blue"
        />
        <span
          class="ml-1 text-size-12"
          :class="{ 'text-blue': option.checked }"
          >{{ option.text }}</span
        >
      </div>
    </label>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { FormOption } from "@/types/form/FormOption";

type CheckboxOption = FormOption & { checked: boolean };

@Component({
  components: {
    FeatherIcon
  }
})
export default class FormCheckboxGroupItems extends Vue {
  @Prop({
    type: Array,
    required: true,
    default: []
  })
  checkedItems!: string[];

  @Prop({
    type: Array,
    required: true,
    default: []
  })
  options!: FormOption[];

  @Prop({
    type: String,
    required: true,
    default: ""
  })
  name!: string;

  @Prop({
    type: String,
    default: ""
  })
  textField!: string;

  @Prop({
    type: String,
    default: ""
  })
  valueField!: string;

  @Prop({
    type: String,
    default: ""
  })
  variant!: string;

  get checkedItemsValue() {
    return this.checkedItems;
  }

  set checkedItemsValue(v) {
    this.$emit("input", v);
  }

  get optionItems(): CheckboxOption[] {
    return this.options.map(option => {
      const textVal = this.textField
        ? option[this.textField as keyof FormOption]
        : option.text;
      const valueVal = this.valueField
        ? option[this.valueField as keyof FormOption]
        : option.value;
      const checkedVal = this.checkedItems.includes(valueVal);
      return {
        text: textVal,
        value: valueVal,
        checked: checkedVal
      };
    });
  }
}
</script>

<style lang="scss" scoped>
.checkbox-group-items {
  display: flex;
  flex-wrap: wrap;
  margin-right: -8px;
  margin-left: -8px;

  &__item {
    display: block;
    flex-basis: 50%;
    padding-right: 8px;
    padding-left: 8px;
    cursor: pointer;

    &:nth-child(n + 3) {
      margin-top: 8px;
    }
  }

  &__item-content {
    display: inline-flex;
    align-items: center;

    span {
      font-size: 14px !important;
    }

    svg {
      min-width: 18px;
    }
  }

  // スタック表示用バリアント
  &.stacked {
    display: block;
    margin: 0;

    .checkbox-group-items__item {
      display: flex;
      flex-basis: auto;
      align-items: center;
      padding: 16px;
      margin: 0;
      border-bottom: 1px solid #e5e5e5;

      &:first-child {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }

      &:last-child {
        border-bottom: none;
        border-bottom-right-radius: 8px;
        border-bottom-left-radius: 8px;
      }

      &:has(input:checked) {
        background-color: #f3fcff;
      }

      &:nth-child(n + 3) {
        margin-top: 0;
      }

      .checkbox-group-items__item-content {
        width: 100%;
      }
    }
  }
}
</style>
